import axios from "axios";

export const BASE_URL = "https://backend.secuber.io/v2";
const token = localStorage.getItem("token");

export const axiosV2Instance = axios.create({
    baseURL: BASE_URL,
    headers: !!token ? { Authorization: `Bearer ${token}` } : null,
});